var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c("div", [_c("loading", { attrs: { show: _vm.loading } })], 1)
      : _c("div", [
          !_vm.valid
            ? _c("div", {}, [
                _c(
                  "div",
                  {
                    staticClass: "font-20",
                    staticStyle: {
                      position: "fixed",
                      top: "50%",
                      left: "50%",
                      color: "#000",
                      transform: "translate(-50%, -50%)"
                    }
                  },
                  [_vm._v("数据无效")]
                )
              ])
            : _c("div", [
                _c(
                  "div",
                  {
                    staticClass:
                      "content-row content-row-center content-align-center person-info",
                    attrs: { id: "head" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "content-row content-row-center content-align-center auto-width avatar-container"
                      },
                      [
                        _c("img", {
                          staticClass: "avatar",
                          attrs: { src: _vm.avatar }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "content-row content-row-column auto-width font-14",
                        staticStyle: { color: "#fff" }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.customer.name ? _vm.customer.name : "--")
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("***CM  **KG")])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "risk-show-container" }, [
                  _c(
                    "div",
                    { staticClass: "swiper-box" },
                    [
                      _c(
                        "swiper",
                        {
                          ref: "postureSwiper",
                          attrs: { options: _vm.swiperOption }
                        },
                        [
                          _c(
                            "swiper-slide",
                            {
                              attrs: {
                                "data-riskData": JSON.stringify(_vm.face.data)
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    position: "relative",
                                    padding: "0 2rem"
                                  },
                                  attrs: { id: "face" }
                                },
                                _vm._l(_vm.face.data, function(risk) {
                                  return _c(
                                    "div",
                                    {
                                      key: risk.id,
                                      staticClass:
                                        "content-row content-align-center font-14 auto-width risk-tag",
                                      style: !risk.valid
                                        ? "display: none"
                                        : "display: " +
                                          (risk.level == "normal"
                                            ? "none"
                                            : "flex") +
                                          ";top: " +
                                          _vm.face.scale * risk.coord.top +
                                          "px; " +
                                          (risk.coord.left
                                            ? "left:" + risk.coord.left + "px"
                                            : "right:" +
                                              risk.coord.right +
                                              "px")
                                    },
                                    [
                                      _c("div", { staticClass: "risk-icon" }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(risk.name))])
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "swiper-slide",
                            {
                              attrs: {
                                "data-riskData": JSON.stringify(_vm.side.data)
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    position: "relative",
                                    padding: "0 2rem"
                                  },
                                  attrs: { id: "side" }
                                },
                                _vm._l(_vm.side.data, function(risk) {
                                  return _c(
                                    "div",
                                    {
                                      key: risk.id,
                                      staticClass:
                                        "content-row content-align-center font-14 auto-width risk-tag",
                                      style: !risk.valid
                                        ? "display: none"
                                        : "display: " +
                                          (risk.level == "normal"
                                            ? "none"
                                            : "flex") +
                                          ";top: " +
                                          _vm.side.scale * risk.coord.top +
                                          "px; left: " +
                                          risk.coord.left +
                                          "px"
                                    },
                                    [
                                      _c("div", { staticClass: "risk-icon" }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(risk.name))])
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "swiper-pagination posture-swiper-pagination",
                            attrs: { slot: "pagination" },
                            slot: "pagination"
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "swiper-button-prev",
                            attrs: { slot: "button-prev" },
                            slot: "button-prev"
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "swiper-button-next",
                            attrs: { slot: "button-next" },
                            slot: "button-next"
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "content-row content-align-center auto-width font-14 detail-btn",
                          staticStyle: { padding: "0 1rem" },
                          attrs: { id: "btn" },
                          on: {
                            click: function($event) {
                              _vm.go("riskDetail")
                            }
                          }
                        },
                        [
                          _c("span", [_vm._v("症状详情")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "right-arrow" })
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "fixed-bg" })
              ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "content-row content-row-center content-align-center data-info"
      },
      [
        _c("div", { staticClass: "badge" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "content-row content-row-column auto-width",
            staticStyle: { color: "#fff" }
          },
          [
            _c(
              "div",
              {
                staticClass: "font-16",
                staticStyle: { "line-height": ".8rem" }
              },
              [
                _vm._v("体态综合评分："),
                _c(
                  "span",
                  { staticClass: "font-20", staticStyle: { color: "#57d90e" } },
                  [_vm._v("--")]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "font-12", staticStyle: { color: "#d5eef1" } },
              [
                _vm._v("未来5年发生体态风险的概率高于"),
                _c(
                  "span",
                  { staticClass: "font-16", staticStyle: { color: "#a01315" } },
                  [_vm._v("--%")]
                ),
                _vm._v("的人")
              ]
            )
          ]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dc7cce2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dc7cce2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = null
// module chunks = 